export var EZIndices = /*#__PURE__*/function (EZIndices) {
  EZIndices[EZIndices["Default"] = 1000] = "Default";
  EZIndices[EZIndices["Status"] = 1001] = "Status";
  EZIndices[EZIndices["Header"] = 1002] = "Header";
  EZIndices[EZIndices["Overlay"] = 2003] = "Overlay";
  return EZIndices;
}({});